module.exports = __webpack_public_path__ + "static/media/sprite.83de43af.svg";